<div class="modalMain">
  <header class="modalTitle">
    <span class="h2">Define Your <b>Sub-System</b>Template</span>
  </header>
  <div class="modalBody">
    <div class="form-group deviceSelect">
      <label>Select the First/master <b>Driver Asset</b> type</label>
      <select [(ngModel)]="selecteddevice" class="custom_select form-control"
        (change)="onDeviceChange($event.target.value,'click_event')">
        <option *ngFor="let device of typesofdevice " value="{{device}}">{{device}}
        </option>
      </select>
    </div>
    <div class="radio-grp" *ngIf="subAssetType ==='MOTOR'">
      <mat-radio-group (change)="onRadiobuttonSelect($event.value)" [(ngModel)]="selectedMotor">
        <mat-radio-button value="IM"> Induction Motor</mat-radio-button>
        <mat-radio-button value="DC"> DC Motor</mat-radio-button>
        <mat-radio-button value="SM"> Synchronous Motor</mat-radio-button>
        <mat-radio-button value="ALT">Alternator</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="sensorPosition" *ngIf="this.selecteddevice !='' ">
      <div class="sensorPart">
        <div class="sensors">
          <label>Sensor Position</label>
          <div class="radio-group" style="margin-right: 20px;">
            <mat-checkbox id="frame_primary" (change)="onchange($event)">Frame</mat-checkbox>
            <mat-checkbox id="de_primary" (change)="onchange($event)">DE</mat-checkbox>
            <mat-checkbox id="nde_primary" (change)="onchange($event)">NDE</mat-checkbox>
          </div>
        </div>
        <!-- <div class="col-md-12 col" *ngIf="this.devicewithFrame || this.devicewithDE || this.devicewithNDE">
         
          <mat-checkbox id="frame_master" *ngIf="this.devicewithFrame" (change)="onassignmaster($event)">Frame</mat-checkbox>
          <mat-checkbox id="de_master" *ngIf="this.devicewithDE"  (change)="onassignmaster($event)">DE</mat-checkbox>
          <mat-checkbox id="nde_master" *ngIf="this.devicewithNDE"  (change)="onassignmaster($event)">NDE</mat-checkbox>
        </div> -->
        <div class="sensors" *ngIf="this.devicewithFrame || this.devicewithDE || this.devicewithNDE">
          <label>Choose Master</label>
          <mat-radio-group class="radio-group" [(ngModel)]="masterselected" (change)=" onassignmaster($event.value, 'click_event')">
            <mat-radio-button [disabled]="editable" *ngIf="this.devicewithFrame" value="frame">
              Frame
            </mat-radio-button>
            <mat-radio-button [disabled]="editable" *ngIf="this.devicewithDE" value="de">
              DE
            </mat-radio-button>
            <mat-radio-button [disabled]="editable" *ngIf="this.devicewithNDE" value="nde">
              NDE
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="sensorPart" >
        <div class="sensors">
          <label>Device on Coupling</label>
          <div class="radio-group">      
            <mat-checkbox id="Couple" (change)="onchange($event)" [checked]="this.deviceoncouple"></mat-checkbox>
          </div>
        </div>
       
        <mat-radio-group class="radio-group" [(ngModel)]="masterselected" (change)=" onassignmaster($event.value, 'click_event')">
          <mat-radio-button [disabled]="editable" *ngIf="this.deviceoncouple" value="couple">
            Choose device on coupling as master
          </mat-radio-button>
        </mat-radio-group>

      </div>
      <div class="addDevice" *ngIf="this.selecteddevice=='MOTOR'" >
        <mat-checkbox id="yes/no" (change)="onyesno($event)" [checked]="this.opensecondimage">Add <b>Device Asset</b> at the drive end  of the motor</mat-checkbox>
      </div>
    </div>
    <div class="sensorPosition" *ngIf="selecteddevice=='MOTOR' && this.opensecondimage==true " >
      <div class="form-group deviceSelect">
        <label for=""><b>Driven Asset Type</b></label>
        <select [(ngModel)]="selecteddevicewithmotor" class="custom_select form-control" (change)="onDrivenChange($event.target.value,'click_event')">
          <option *ngFor="let device of driventypesofdevice " value="{{device}}">{{device}}
          </option>
        </select>
      </div>

      
      <div class="sensorPart" *ngIf="opensecondimage">
        <div class="sensors">
          <label>Sensor Position</label>
          <div class="radio-group">      
            <mat-checkbox id="frame_secondary" (change)="onchange($event)">Frame</mat-checkbox>
            <mat-checkbox id="de_secondary" (change)="onchange($event)">DE</mat-checkbox>
            <mat-checkbox id="nde_secondary" (change)="onchange($event)">NDE</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
      <div class="view-wrapper" [ngClass]="isHorizontalView ? 'horizontal-wrap' : 'vertical-wrap'">
        <div class=" motorView EditView rotatableBox {{selectedAssetType}} {{selectedDrivenAssetType}}" [ngClass]="isHorizontalView ? 'horizontal' : 'vertical'">
          <div class="motor left {{selectedAssetType}}"   >
            <span class="left"><button *ngIf="devicewithNDE" [disabled]="true">S</button></span>
            <span class="center"><button *ngIf="devicewithFrame" [disabled]="true">S</button></span>
            <span class="right"><button *ngIf="devicewithDE" [disabled]="true">S</button></span>

            <img  *ngIf="this.primaryDevice.primary.device !=''" src="{{imgSrc}}">
          </div>
          <div  class=" motor right {{selectedDrivenAssetType}}" *ngIf="selecteddevice=='MOTOR' && this.opensecondimage && this.selecteddevicewithmotor !=''" >
            <span class="coupleLeft2"><button *ngIf="deviceoncouple" class="{{selectedDrivenAssetType}}" [disabled]="true">S</button></span>
            <span class="left"><button *ngIf="SecondDevicewithDE" [disabled]="true">S</button></span>
            <span class="center"><button *ngIf="SecondDevicewithFrame" [disabled]="true">S</button></span>
            <span class="right"><button *ngIf="SecondDevicewithNDE" [disabled]="true">S</button></span>
            <img *ngIf="this.primaryDevice.secondary.device !='' " src="{{img2src}}">
          </div>
        </div>
      </div>
   <div class="toggle-container">
    <mat-slide-toggle
      [(ngModel)]="isHorizontalView"
      class="styled-toggle"
    >
      <mat-icon class="toggle-icon">
        {{ isHorizontalView ?  'view_stream' : 'view_column' }}
      </mat-icon>
      <span class="toggle-text">
        {{ isHorizontalView ? 'Horizontal View' : 'Vertical View' }}
      </span>
    </mat-slide-toggle>
  </div>
  <div class="modalFooter">
    <button mat-raised-button color="primary" (click)="onclickcontinue()">Continue</button>
    <button mat-raised-button color="warm" (click)="onclickclose()">close</button>
  </div>
</div>